module.exports = __webpack_public_path__ + "static/development-animate-640e22d487d825cf012c04bc6588698c.svg";